import React from "react";
import ToastNotification from "components/Toast/ToastNotification";
import toast, { Toaster, ToastBar } from "react-hot-toast";

// Providers
import { ModalProvider } from "contexts/ModalProvider";
import { AuthProvider } from "contexts/AuthContext";

// Security
import ContentSecurityPolicy from "components/security/ContentSecurityPolicy";

// Routes
import AppRoutes from "./routes";

// Import scss
import "./assets/scss/theme.scss";

const App = () => {
  return (
    <AuthProvider>
      <ContentSecurityPolicy />
      <ModalProvider>
        <AppRoutes />
      </ModalProvider>
      <Toaster position="top-right" gutter={8} containerClassName="react-toast-notifications__container">
        {(t) => <ToastBar toast={t}>{() => <div className={`react-toast-notifications__toast ${t.visible ? "toast-enter" : "toast-exit"}`}>{typeof t.message === "object" ? t.message : <ToastNotification type={t.type} title={Array.isArray(t.message) ? t.message[0] : ""} description={Array.isArray(t.message) ? t.message[1] : t.message} onSecondaryClick={() => toast.dismiss(t.id)} />}</div>}</ToastBar>}
      </Toaster>
    </AuthProvider>
  );
};

export default App;
